import React, { useState } from "react";

const questions = [
  {
    id: 1,
    text: "1. Công ty đột ngột thông báo đổi phần mềm làm việc mới. Phản ứng đầu tiên của bạn là:",
    options: {
      A: "Không bất ngờ lắm. Tôi đã thấy phần mềm cũ dạo này chậm và hay lỗi, đoán trước thể nào cũng đổi.",
      B: "Nhào vô mở phần mềm mới lên click thử xem nó hoạt động ra sao ngay lập tức.",
      C: "Cằn nhằn: 'Trời ơi, cái cũ đang xài ngon lành quen tay mà đổi chi cho cực vậy?'",
      D: "Lúc đầu hơi bực vì phải học lại từ đầu, nhưng rồi tự nhủ ai cũng phải xài nên đành mở hướng dẫn ra coi."
    }
  },
  {
    id: 2,
    text: "2. Sếp thay đổi toàn bộ chỉ tiêu (KPI) của team vào giữa năm. Bạn sẽ làm gì?",
    options: {
      A: "Tôi đã lờ mờ nhận ra định hướng thị trường thay đổi từ mấy tháng trước rồi.",
      B: "Bắt tay vào lập kế hoạch chạy số cho KPI mới luôn, nghĩ nhiều làm gì.",
      C: "Lên group chat than vãn, đòi sếp phải giữ nguyên KPI cũ vì như vậy là ép nhân viên.",
      D: "Sợ hãi vì sợ không đạt số, nhưng sau vài ngày suy nghĩ lại, tôi bắt đầu tìm cách thích nghi."
    }
  },
  {
    id: 3,
    text: "3. Khách hàng 'ruột' mang lại doanh thu lớn bỗng dưng hủy hợp đồng. Bạn thấy thế nào?",
    options: {
      A: "Đã có dự cảm không lành từ tuần trước khi họ bắt đầu phản hồi email chậm lại.",
      B: "Lấy danh sách data ra gọi điện tìm kiếm khách hàng mới ngay lập tức.",
      C: "Cay cú, cảm thấy bất công và cứ hy vọng họ sẽ đổi ý quay lại.",
      D: "Tự cười bản thân vì đã quá phụ thuộc vào một 'tô cơm' duy nhất, rồi xốc lại tinh thần đi tìm cơ hội mới."
    }
  },
  {
    id: 4,
    text: "4. Cơ cấu tổ chức thay đổi, bạn bị điều chuyển sang làm việc với một ông sếp mới toanh.",
    options: {
      A: "Tôi hay để ý tin tức nội bộ nên đã nắm được vụ chuyển giao này từ lâu.",
      B: "Hẹn sếp mới cà phê 15 phút để chốt ngay cách thức làm việc chung.",
      C: "Nhớ sếp cũ da diết, so sánh sếp mới với sếp cũ và có ý định chống đối ngầm.",
      D: "Ban đầu rất ngại, nhưng sau đó quyết định cởi mở để xem sếp mới có gì hay để học hỏi."
    }
  },
  {
    id: 5,
    text: "5. Nghe tin đồn kinh tế khó khăn, công ty sắp cắt giảm phúc lợi. Bạn phản ứng ra sao?",
    options: {
      A: "Đã đánh hơi thấy mùi từ báo cáo tài chính quý trước, bắt đầu thắt lưng buộc bụng.",
      B: "Xách ba lô lên đi sale thêm, cày gấp đôi để chứng minh giá trị không thể thay thế của mình.",
      C: "Ngồi lo lắng, chửi thề và cho rằng công ty bóc lột.",
      D: "Biết là buồn, nhưng quyết định dùng thời gian này để cập nhật lại CV và học thêm kỹ năng mới."
    }
  },
  {
    id: 6,
    text: "6. Khi sếp yêu cầu cả team áp dụng AI vào quy trình làm việc hàng ngày:",
    options: {
      A: "Tôi đã đọc tin tức về AI mỗi ngày và biết ngày này sẽ tới.",
      B: "Mở ChatGPT lên dùng thử để viết email và làm slide luôn.",
      C: "Phản đối kịch liệt, bảo rằng AI làm mất đi sự sáng tạo và sợ AI cướp việc.",
      D: "Lúc đầu sợ dùng sai bị chửi, nhưng thấy anh em xài mượt quá nên cũng lò dò học theo."
    }
  },
  {
    id: 7,
    text: "7. Bạn phát hiện quy trình làm việc hiện tại quá rườm rà và không còn hiệu quả.",
    options: {
      A: "Tôi thường là người đầu tiên trong team chỉ ra những điểm bất hợp lý này.",
      B: "Tự động cắt giảm các bước thừa và làm thử theo cách mới xem sếp có la không.",
      C: "Biết là rườm rà nhưng sếp bảo sao làm vậy, cứ làm theo lối cũ cho an toàn.",
      D: "Chấp nhận bỏ thói quen cũ dù nó rất thoải mái, để tập làm quen với quy trình chuẩn hơn."
    }
  },
  {
    id: 8,
    text: "8. Thấy đồng nghiệp thăng tiến vù vù nhờ mạnh dạn áp dụng chiến lược mới, bạn nghĩ gì?",
    options: {
      A: "Tôi đã phân tích được vì sao cách làm của họ lại hiệu quả trong bối cảnh hiện tại.",
      B: "Sang hỏi thẳng bí quyết và áp dụng ngay vào công việc của mình.",
      C: "Cho rằng họ chỉ gặp may hoặc biết cách nịnh sếp.",
      D: "Nhận ra sự bảo thủ đã kìm hãm mình, và bắt đầu tự ép bản thân phải thay đổi."
    }
  },
  {
    id: 9,
    text: "9. Nếu một ngày 'tô cơm' (công việc ổn định hiện tại) của bạn biến mất:",
    options: {
      A: "Thực ra tôi đã biết 'cơm' bắt đầu ôi thiu từ tháng trước rồi.",
      B: "Không chần chừ, lao ngay ra thị trường để tìm 'cơm' mới.",
      C: "Ngồi lỳ một chỗ, than thân trách phận và đợi ai đó mang 'cơm' tới cho.",
      D: "Vượt qua nỗi sợ hãi ban đầu, nhận ra thế giới ngoài kia còn nhiều món ngon hơn cơm."
    }
  },
  {
    id: 10,
    text: "10. Từ nào miêu tả đúng nhất thái độ của bạn với chữ 'Thay đổi'?",
    options: {
      A: "Là quy luật tất yếu, đoán trước được.",
      B: "Hành động ngay, chần chừ là đói.",
      C: "Là kẻ thù phá bĩnh sự bình yên của tôi.",
      D: "Đau đớn lúc đầu, nhưng mang lại sự tự do lúc sau."
    }
  },
  {
    id: 11,
    text: "11. Bị sếp gọi vào phòng chê dự án đang đi sai hướng hoàn toàn:",
    options: {
      A: "Đã thấy sếp nhíu mày từ lúc nộp bản draft 1 tuần trước.",
      B: "Về bàn mở file ra đập đi xây lại cái rẹt.",
      C: "Phân bua, cãi tay đôi rắng do sếp brief không rõ ngay từ đầu.",
      D: "Nuốt cục tức vào trong, bình tâm lại và xin sếp chỉ cho hướng đi mới đúng đắn hơn."
    }
  },
  {
    id: 12,
    text: "12. Nhìn lại một biến cố lớn đã từng xảy ra ở công ty, bạn thường:",
    options: {
      A: "Đánh giá xem liệu sắp tới thị trường còn biến đổi nào tương tự không.",
      B: "Nhớ lại lúc đó mình đã xử lý sự cố nhanh gọn lẹ ra sao.",
      C: "Vẫn còn ấm ức mỗi khi ai đó nhắc lại chuyện cũ.",
      D: "Cười nhẹ tự giễu mình lúc đó đã quá trẻ con, nay mình đã bản lĩnh hơn nhiều."
    }
  }
];

const resultsData = {
  A: { title: "NHÓM 'ĐÁNH HƠI' (SNIFF) - NGƯỜI NHẠY BÉN 👃", desc: "Bạn như có radar gắn trong đầu! Bạn luôn quan sát thị trường, để ý thái độ sếp và khách hàng. Bạn ngửi thấy sự thay đổi từ khi nó còn chưa bắt đầu. Điểm mạnh: Không bao giờ bị bất ngờ. Lời khuyên: Đôi khi đoán được rồi thì nhớ báo cho anh em trong team biết để cùng chuẩn bị nhé!" },
  B: { title: "NHÓM 'CHẠY VỌT' (SCURRY) - NGƯỜI HÀNH ĐỘNG 🏃‍♂️", desc: "Không nói nhiều, làm thôi! Bạn ghét lý thuyết rườm rà. 'Tô cơm' mất thì đi kiếm tô khác. Khả năng thích nghi và tốc độ thực thi của bạn là vũ khí sinh tồn mạnh nhất chốn công sở. Lời khuyên: Chạy nhanh là tốt, nhưng nhớ nhìn kỹ bản đồ kẻo chạy nhầm đường nha!" },
  C: { title: "NHÓM 'Ù LÌ' (HEM) - NGƯỜI BẢO THỦ 🛑", desc: "Bạn cực kỳ ghét sự thay đổi. Bạn thích vùng an toàn, quen việc, quen người. Khi biến cố xảy ra, phản xạ đầu tiên của bạn là chống đối, than vãn và chờ đợi phép màu. Lời khuyên chân thành: Công ty không trả tiền cho sự hoài niệm. Càng bám víu vào 'tô cơm' cũ, bạn càng nhanh bị đào thải. Hãy mở lòng ra!" },
  D: { title: "NHÓM 'THỨC TỈNH' (HAW) - NGƯỜI BIẾT VƯỢT LÊN NỖI SỢ 🌅", desc: "Bạn giống đại đa số chúng ta: Mới đầu thấy đổi mới là sợ, là lười, là muốn cự cãi. Nhưng điểm ăn tiền của bạn là sự THỨC TỈNH. Bạn biết cười vào sự bướng bỉnh của chính mình, vượt qua nỗi sợ và học cách sinh tồn mới. Lời khuyên: Lần tới có thay đổi, hãy rút ngắn khoảng thời gian 'sợ hãi' lại để thành công nhanh hơn nhé!" }
};

export default function RiceBowlAssessment() {
  const [answers, setAnswers] = useState({});
  const [result, setResult] = useState(null);

  const handleSelect = (questionId, optionKey) => {
    setAnswers({ ...answers, [questionId]: optionKey });
  };

  const calculateResult = () => {
    if (Object.keys(answers).length < questions.length) {
      alert("Ê khoan, check lại xem còn sót câu nào chưa click không bồ ơi!");
      return;
    }

    const counts = { A: 0, B: 0, C: 0, D: 0 };
    Object.values(answers).forEach((ans) => { counts[ans]++; });

    let highestScore = 0;
    let winningStyle = "A";

    for (const [key, value] of Object.entries(counts)) {
      if (value > highestScore) {
        highestScore = value;
        winningStyle = key;
      }
    }

    setResult(resultsData[winningStyle]);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div style={{ maxWidth: "600px", margin: "0 auto", padding: "20px", fontFamily: "sans-serif" }}>
      <h1 style={{ textAlign: "center", color: "#333" }}>Kiểu Phản Ứng Khi "Mất Tô Cơm" 🍚</h1>
      
      <div style={{ backgroundColor: "#e2e3e5", padding: "20px", borderRadius: "8px", borderLeft: "5px solid #6c757d", marginBottom: "30px", color: "#383d41" }}>
        <p style={{ margin: "0 0 10px 0", fontWeight: "bold", fontSize: "16px" }}>💡 Bạn có biết?</p>
        <p style={{ margin: "0", lineHeight: "1.5", fontSize: "15px" }}>
          Mọi thứ từ quy trình, KPI, đến ông sếp của bạn đều có thể thay đổi sau 1 đêm. Ai thích nghi nhanh thì sống thảnh thơi, ai ôm khư khư quá khứ thì chuốc lấy bực tức. Bạn là kiểu người nào khi biến cố ập đến?
        </p>
        
        <div style={{ marginTop: "20px", padding: "15px", backgroundColor: "#ffffff", borderRadius: "8px", border: "1px dashed #6c757d" }}>
          <p style={{ margin: "0 0 10px 0", fontWeight: "bold", fontSize: "15px", color: "#333" }}>📚 Lộ Trình "Tu Luyện" Sinh Tồn:</p>
          <ul style={{ margin: "0", paddingLeft: "20px", fontSize: "15px", lineHeight: "1.8", color: "#333" }}>
            <li>
              <strong>Bước 1:</strong> Xem Video "Ai chuyển tô cơm của chúng ta?" <a href="https://notebooklm.google.com/notebook/907c6d8f-a754-4258-a081-2395ce4ef770?artifactId=5da20fd5-372e-4e6f-816c-377b56fcf835" target="_blank" rel="noreferrer" style={{ color: "#007BFF", textDecoration: "none", fontWeight: "bold" }}>[Xem Tại Đây]</a>
            </li>
            <li>
              <strong>Bước 2:</strong> Nghe Podcast chém gió bí kíp <a href="https://notebooklm.google.com/notebook/907c6d8f-a754-4258-a081-2395ce4ef770?artifactId=9933dbdb-a730-48a4-ba4c-d4701ac519b0" target="_blank" rel="noreferrer" style={{ color: "#007BFF", textDecoration: "none", fontWeight: "bold" }}>[Nghe Tại Đây]</a>
            </li>
            <li>
              <strong>Bước 3:</strong> Làm bài Trắc nghiệm bản thân (ngay bên dưới 👇)
            </li>
            <li>
              <strong>Bước 4:</strong> Làm bài Kiểm tra kiến thức <a href="/kiem-tra-to-com" style={{ color: "#007BFF", textDecoration: "none", fontWeight: "bold" }}>[Test Tại Đây]</a>
            </li>
          </ul>
        </div>
      </div>

      {!result ? (
        <div>
          {questions.map((q) => (
            <div key={q.id} style={{ marginBottom: "25px", padding: "15px", border: "1px solid #ddd", borderRadius: "8px", backgroundColor: "#f9f9f9" }}>
              <p style={{ fontWeight: "bold", marginTop: "0" }}>{q.text}</p>
              <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                {Object.entries(q.options).map(([key, text]) => (
                  <label key={key} style={{ cursor: "pointer", display: "flex", alignItems: "flex-start", gap: "10px", padding: "5px" }}>
                    <input
                      type="radio"
                      name={`question-${q.id}`}
                      value={key}
                      checked={answers[q.id] === key}
                      onChange={() => handleSelect(q.id, key)}
                      style={{ width: "20px", height: "20px", marginTop: "3px" }}
                    />
                    <span style={{ lineHeight: "1.4" }}>{text}</span>
                  </label>
                ))}
              </div>
            </div>
          ))}

          <button 
            onClick={calculateResult} 
            style={{ width: "100%", padding: "15px", fontSize: "18px", backgroundColor: "#dc3545", color: "white", border: "none", borderRadius: "8px", cursor: "pointer", fontWeight: "bold" }}
          >
            Chốt & Xem Kết Quả!
          </button>
        </div>
      ) : (
        <div style={{ textAlign: "center", padding: "30px", border: "2px solid #dc3545", borderRadius: "10px", backgroundColor: "#f8d7da" }}>
          <h2>Kết Quả Của Bạn:</h2>
          <h1 style={{ color: "#721c24", fontSize: "28px" }}>{result.title}</h1>
          <p style={{ fontSize: "18px", lineHeight: "1.6", color: "#491217" }}>{result.desc}</p>
          <button 
            onClick={() => { setResult(null); setAnswers({}); }} 
            style={{ marginTop: "20px", padding: "10px 20px", backgroundColor: "#333", color: "white", border: "none", borderRadius: "5px", cursor: "pointer" }}
          >
            Làm lại bài test
          </button>
        </div>
      )}
    </div>
  );
}